import { callApi, LONG_API_TIMEOUT_MS } from './ApiClient';

/*** 送付先NGリストの一覧取得API ***/
const getNgSendings = (data, dispatch) => {
  return callApi('GET', `/ng-sendings`, data, dispatch);
}

/*** 指定したidのng_sendingsを取得API ***/
const getNgSendingsById = (id, dispatch) => {
  return callApi('GET', `/ng-sendings/${id}`, null, dispatch);
}

/*** 送付先NGリストを登録するAPI ***/
const postNgSendings = (data, dispatch) => {
  // 一括登録でサーバー側がset_time_limit(3600)される重いAPIのため長めに設定する
  return callApi('POST', `/ng-sendings`, data, dispatch, false, {
    timeout: LONG_API_TIMEOUT_MS,
  });
}

/*** 指定したidのng_sendingsを更新るAPI ***/
const putNgSendings = (data, dispatch) => {
  return callApi('PUT', `/ng-sendings/${data.id}`, data, dispatch);
}

/*** 指定したidのng_sendingsを削除るAPI ***/
const deleteNgSendingsById = (id, dispatch) => {
  return callApi('DELETE', `/ng-sendings/${id}`, null, dispatch);
}

/*** 指定した検索条件のng_sendingsと紐づくng_sending_addressesも削除されます。 ***/
const deleteNgSendings = (data, dispatch) => {
  // 一括削除でサーバー側がset_time_limit(3600)される重いAPIのため長めに設定する
  return callApi('POST', `/ng-sendings/destroyMulti`, data, dispatch, false, {
    timeout: LONG_API_TIMEOUT_MS,
  });
}

export const NgSendingsApi = {
  getNgSendings,
  getNgSendingsById,
  postNgSendings,
  putNgSendings,
  deleteNgSendingsById,
  deleteNgSendings,
}



// WEBPACK FOOTER //
// ./src/redux/api/NgSendingsApi.js